import request from '@/utils/request'
let baseUrl = '/api/competition/'
let authUrl = '/auth/competition/'
export function getList(pageNO,type,query) {

    return request({
      url: baseUrl+'list'+"/"+type+"/"+pageNO,
      method: 'get',
      params: query 
    })
  }
export function listQuestion(compId,stageId){
  return request({
    url: authUrl+'exam/list',
    method: 'get',
    params: { compId: compId,stageId: stageId}
  })
}
export function listQuestion2(compId,stageId){
  return request({
    url: authUrl+'exam/list2',
    method: 'get',
    params: { compId: compId,stageId: stageId}
  })
}

export function submit(compId,stageId,qList){
  return request({
    url: authUrl+ "exam/submit",
    method: 'post',
    data: {
      compId: compId,
      stageId: stageId,
      qList: qList
    }
  })
}
export function position(q){
  return request({
    url: baseUrl+ "position",
    method: 'get',
    params: q
  })
}

export function positionAll(q){
  return request({
    url: baseUrl+ "positionAll",
    method: 'get',
    params: q
  })
}

export function reportDetail(reportId){
  return request({
    url: baseUrl+ "reportDetail",
    method: 'get',
    params: {reportId: reportId}
  })
}

export function getGroup(compId,stageId){
  return request({
    url: baseUrl+ "group",
    method: 'get',
    params: {
      compId: compId,
      stageId: stageId
    }
  })
}

export function get(q){
  return request({
    url: baseUrl+ "get",
    method: 'get',
    params: q
  })
}
export function startExam(q){
  return request({
    url: authUrl+ "exam/start",
    method: 'get',
    params: q
  })
}

export function memberRank(q){
  return request({
    url: baseUrl+"memberRank",
    method: 'get',
    params: q
  })
}


// WEBPACK FOOTER //
// ./src/api/competition.js